import { Features } from "../../../../../../../../../../frontend/libs/shared/src/lib/types/types";

declare var require: any;
export class CoreHeaderDetailsController {
  isOptimizedMix: any;
  isPlanUnsaved: boolean;
  isPlanPublished: boolean;
  isOptimizedMixTooltipOpen: boolean = true;
  activePurchasePlan: any;
  activePlanMixStatus: string;
  featureList: Features;
  planWasSaved: boolean;



  constructor(private $scope) {
    'ngInject';

    $scope.iconProperties = {
      bgColor: "yellow",
      hoverBgColor: "light-yellow",
      color: "white",
      hoverColor: "white",
      iconTextBottom: "0px",
      iconSize: "12px",
      disabled: false,
      disabledColor: "light-yellow",
      width: "22px",
      height: "22px"
    }

    $scope.iconData = {
      type: {
        prefix: "fas",
        iconName: "lock",
        icon: [
          448,
          512,
          [
            128274
          ],
          "f023",
          "M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"
        ]
      },
      class: "fa fa-lock"
    }

    $scope.onLockStatusChange = (status) => {
      this.isOptimizedMix = !this.isOptimizedMix;
      this.isPlanUnsaved =
        this.activePurchasePlan.basedOn.status !== 'Saved' &&
          this.activePurchasePlan.basedOn.status !== 'Published'
          ? true
          : false;
      this.isPlanPublished =
        this.activePurchasePlan.basedOn.status === 'Published';
      $scope.$emit('setLockStatusEvent', status);
    };

    $scope.isCustomPlan = () => {
      return this.activePurchasePlan?.planChanged && this.activePurchasePlan?.basedOn.status !== 'Published';
    }
  }

  onLockMouseHover(status) {
    this.isOptimizedMixTooltipOpen = status;
  }

  getTrayClass(isOptimizedMix, rfp, featureList) {
    let trayClass = '';
    if (isOptimizedMix) {
      trayClass = `${trayClass} reoptimized-mix-tooltip-bed`;
    }

    if (rfp?.buyer?.organizationType === 'GPO') {
      trayClass = `${trayClass} gpo-bg`;
    }
    return trayClass;
  }
}

export const CoreHeaderDetailsComponent = {
  bindings: {
    details: '<',
    account: '<',
    featureList: '<',
    attachments: '<',
    planName: '<',
    planLastModifiedBy: '<',
    planLastModifiedDate: '<',
    isPlanUnsaved: '<',
    isPlanPublished: '<',
    isOptimizedMix: '<',
    sellerName: '<',
    purchasePlanningLevel: '<',
    isOptimizedMixTooltipOpen: '<',
    activePlanMixStatus: '<',
    planWasSaved: '<',
    activePurchasePlan: '<',
    isGPO: '<',
  },
  transclude: {
    customCategoryNameField: '?customCategoryNameField',
  },
  template: require('./coreHeaderDetails.component.html'),
  controller: CoreHeaderDetailsController,
};
